module.exports = "<p>\n    table works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /zeit/1e2f5901/src/app/change-log/table/table.component.html
// module id = ../../../../../src/app/change-log/table/table.component.html
// module chunks = main